import React from "react";
import useSWR from "swr";
import { fetcher } from "../../../utils/request";
import Select from "react-select";
import { getUrlWithoutPathname } from "../../../utils/utility";
import { pushDatatoAdobeLayer } from '../../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../../analytics/analyticsObject';
const BookDropDown = ({ selectedBook, setSelectedBook, setContent }) => {
  const { data } =
    useSWR("/api/tableofcontents/books/EN", fetcher, {
      revalidateOnFocus: false,
    }) || [];

  const getBooksList = () => {
    let pmiBooks = data ? data : [];
    const groupedBook = pmiBooks.reduce((object, item) => {
      object[item.book] = [...(object[item.book] || []), item];
      return object;
    }, {});
    pmiBooks = [];
    Object.keys(groupedBook).forEach((key, index) => {
      pmiBooks.push({
        label: groupedBook[key][0].title,
        book: groupedBook[key][0].book,
        value: groupedBook[key].map(item => item.type[0]),
      });

    });

    return pmiBooks;
  };
  const adobeCustomlog = (path) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let url = getUrlWithoutPathname()
    let customLObj = getAdobeAnalyticsCustomLinkObj(path.label, "tocdropdown", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div className="toc-book-dropdown w-full float-left" adoberegion="tocdropdown">
      <div className="inline-block w-full text-sm text-black-600">
        Publication
      </div>
      <div className="block text-sm text-gray-600 mt-2">
        <Select
          id="bookDropDown"
          value={selectedBook}
          options={getBooksList()}
          onChange={(value) => { setSelectedBook(value); adobeCustomlog(value) }}
        ></Select>
      </div>
    </div>
  );
};

export default BookDropDown;
